import React, { forwardRef } from "react";
import "mapbox-gl/dist/mapbox-gl.css";

import Map from "./Map";

const LiveMap = forwardRef(({ onAirplaneSelect, onLoad, onMapClick }, ref) => {
  const aircraftImages = require.context(
    "../../../public/Images/acft_markers",
    false,
    /\.(png|jpe?g|svg)$/
  );

  const handleMapLoad = () => {
    ref.current.addSource("points", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    });

    ref.current.addLayer({
      id: "points",
      type: "symbol",
      source: "points",
      layout: {
        "icon-rotate": ["get", "rotation"],
        "icon-image": [
          "coalesce",
          ["image", ["get", "icon"]],
          ["image", ["get", "fallback_icon"]],
        ],
        "icon-size": 0.5,
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
      },
      paint: {
        "icon-opacity": ["get", "opacity"],
      },
    });

    ref.current.addSource("route", {
      type: "geojson",
      data: {
        type: "Feature",
        properties: {},
        geometry: {
          type: "LineString",
          coordinates: [],
        },
      },
    });
    ref.current.addLayer({
      id: "route",
      type: "line",
      source: "route",
      layout: {
        "line-join": "round",
        "line-cap": "round",
      },
      paint: {
        "line-color": "#000000",
        "line-width": 1,
        "line-dasharray": [2, 1],
      },
    });

    ref.current.on("click", "points", (e) => {
      // Copy coordinates array.
      const coordinates = e.features[0].geometry.coordinates.slice();
      if (
        ref.current.getCenter().lng !== coordinates[0] &&
        ref.current.getCenter().lat !== coordinates[1]
      ) {
        ref.current.flyTo({
          center: coordinates,
        });
      }
      onAirplaneSelect(e.features[0]?.properties?.id);
    });
    if (onLoad) onLoad();
  };
  const handleMapClick = () => {
    if (onMapClick) {
      onMapClick();
    }
  };
  const handleStyleLoad = () => {
    const imageNames = aircraftImages.keys();
    const images = imageNames.map((image) => aircraftImages(image));

    // Lade die spezifischen Bilder
    images.forEach((image, index) => {
      let imageName = imageNames[index].split("./")[1].split(".")[0];

      ref.current.loadImage(image, (error, image) => {
        if (error) {
          console.error("Fehler beim Laden des Bildes: ", error);
        } else {
          ref.current.addImage(imageName, image);
        }
      });
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps

  return (
    <div className="h-full relative">
      <Map
        ref={ref}
        onLoad={handleMapLoad}
        onStyleLoad={handleStyleLoad}
        onMapClick={handleMapClick}
      />
    </div>
  );
});

export default LiveMap;
